module.exports = __webpack_public_path__ + "img/8A7666_3C332C_C6AEA2_54443C-256px.1e90718b.png";